import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../Reducers/store";
import { UserLevelNames } from "../../Models/UserLevel";
import QBApi from "../../Api/QBApi";

/** Persistent alert for SuperAdmins when QuickBooks is disconnected. */
export default function QuickBooksDownBanner() {
  const { userModel } = useAppSelector((state) => state.user);
  const [disconnected, setDisconnected] = useState(false);

  const check = useCallback(async () => {
    if (userModel?.userLevelId !== UserLevelNames.SuperAdmin) {
      setDisconnected(false);
      return;
    }
    try {
      const res = await QBApi.getStatus();
      setDisconnected(!res.data.connected);
    } catch {
      // Don't spam the UI if status can't be loaded (auth/network).
    }
  }, [userModel?.userLevelId]);

  useEffect(() => {
    void check();
    if (userModel?.userLevelId !== UserLevelNames.SuperAdmin) return;
    const id = window.setInterval(() => void check(), 5 * 60 * 1000);
    return () => window.clearInterval(id);
  }, [userModel?.userLevelId, check]);

  if (!disconnected) return null;

  return (
    <div className="mb-4 rounded-lg border border-rose-300 bg-rose-50 px-4 py-3 text-sm text-rose-900 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <span>
        QuickBooks is disconnected. Invoices and customer sync may fail until it
        is reconnected.
      </span>
      <Link
        to="/admin/quickbooks"
        className="font-semibold underline whitespace-nowrap text-rose-950"
      >
        Reconnect QuickBooks
      </Link>
    </div>
  );
}
